export default __webpack_public_path__ + "static/media/Ketryn Gilbert.e0c7292f.png";